// extracted by mini-css-extract-plugin
export var cell = "_64-4";
export var headerCell = "_64-2";
export var rowHeader = "_64-3";
export var table = "_64-1";
export var tableContainer = "_64-0";